module.exports = __webpack_public_path__ + "img/en_backgroundImg.e3d26ecb.jpg";